import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import whatwedoimage3 from "../../assets/images/WhatwedoImage3.png";
import whatwedo3 from "../../assets/images/Whatwedo/whatwedo3.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

const WhatwedoContent = () => {

  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        width: "100%",
        padding: "0rem 0rem",
        display: "flex",
        justifyContent: { xs: "start", md: "flex-start" },
        alignItems: { xs: "center", md: "start" },
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      <Box
        sx={{
          width: { xs: "80%", sm: "55%", md: "40%" },
        }}
      >
        <Box
          sx={{
            width: { xs: "auto", md: "30rem" },
          }}
        >
          <LazyLoadImage
            src={isMdUp ? whatwedoimage3 : whatwedo3}
            effect="blur"
            width="100%"
            height="100%"
          />
        </Box>
      </Box>

      <Box
        sx={{
          width: { xs: "100%", md: "58%" },
          padding: "0rem 2rem 2rem 2rem",
        }}
      >
        <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                paddingLeft: "1.5rem",
                position: "relative",
                "&::before": {
                  content: '"•"',
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  position: "absolute",
                  left: 0,
                },
              }}
            >
              Our innovative approach to on-demand analytics revolutionizes
              decision-making in today's dynamic market landscape. With a focus
              on&nbsp;
              <span
                style={{
                  display: "inline",
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                predictive modeling and growth forecasting
              </span>
              , we empower businesses to anticipate market trends and capitalize
              on growth opportunities proactively.
            </Typography>
          </li>

          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                paddingLeft: "1.5rem",
                position: "relative",
                "&::before": {
                  content: '"•"',
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  position: "absolute",
                  left: 0,
                },
              }}
            >
              Utilizing the&nbsp;
              <span
                style={{
                  display: "inline",
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                Push-Pull Business Architecture Framework
              </span>
              , we provide strategic insights into marketing and sales dynamics,
              enabling businesses to optimize their operations and drive revenue
              growth effectively.
            </Typography>
          </li>

          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                paddingLeft: "1.5rem",
                position: "relative",
                "&::before": {
                  content: '"•"',
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  position: "absolute",
                  left: 0,
                },
              }}
            >
              Our capabilities extend to small area&nbsp;
              <span
                style={{
                  display: "inline",
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                demand-supply estimation
              </span>
              , with precision down to one square kilometer. This granular
              analysis enables businesses to understand localized demand
              patterns and tailor their strategies, accordingly, maximizing
              efficiency and minimizing waste.
            </Typography>
          </li>

          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                paddingLeft: "1.5rem",
                position: "relative",
                "&::before": {
                  content: '"•"',
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  position: "absolute",
                  left: 0,
                },
              }}
            >
              We offer&nbsp;
              <span
                style={{
                  display: "inline",
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                Balanced Scorecard&nbsp;
              </span>
              solutions tailored for brands, providing a holistic view of
              performance across various metrics. This comprehensive approach
              allows businesses to align their strategies with their overarching
              goals and track progress effectively.
            </Typography>
          </li>

          <li>
            <Typography
              component="div"
              sx={{
                color: "rgba(51, 51, 51, 1)",
                fontFamily: "Plus Jakarta Sans",
                marginTop: "1rem",
                fontSize: "1rem",
                paddingLeft: "1.5rem",
                position: "relative",
                "&::before": {
                  content: '"•"',
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  position: "absolute",
                  left: 0,
                },
              }}
            >
              Our&nbsp;
              <span
                style={{
                  display: "inline",
                  color: "rgba(243, 107, 43, 1)",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  fontFamily: "Plus Jakarta Sans",
                }}
              >
                AEI (Advertising Effectiveness Index)&nbsp;
              </span>
              Modeling expertise empowers businesses in media and digital
              allocation and planning. By leveraging advanced analytics, we help
              businesses optimize their marketing budgets, ensuring maximum ROI
              and effective audience targeting.
            </Typography>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default WhatwedoContent;
